import { useEffect, useState } from "react";
import { fetchdestination } from "../services/DestinationsDetaillist";
import { API_BASE } from "../api/apiConfig";
import { useParams } from "react-router-dom";

const MoDestinationsDetaillist = () => {
  const { city } = useParams();
  const [activeTab, setActiveTab] = useState("group");
  const [groupTrips, setGroupTrips] = useState([]);
  const [customTrips, setCustomTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cityData, setCityData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredGroupTrips = groupTrips.filter((trip) =>
    trip.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    trip.city.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredCustomTrips = customTrips.filter((trip) =>
    trip.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    trip.city.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
  const loadTrips = async () => {
    try {
      const result = await fetchdestination(city);

      if (result?.status) {
        setGroupTrips(result.grouptripsdata || []);
        setCustomTrips(result.customizedtripsdata || []);
      }

      if (result?.status && result.citydata?.length > 0) {
        setCityData(result.citydata[0]);
      }

    } catch (err) {
      console.error("Error fetching trips:", err);
    } finally {
      setLoading(false);
    }
  };

  loadTrips();
}, [city]);

  return (
    <>


    <div className="sticky top-0 z-50 bg-white border-b">
        <div className="flex items-center gap-3 px-4 py-3">
          <a href="/">
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-9 w-9">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-arrow-left h-5 w-5"
              >
                <path d="m12 19-7-7 7-7" />
                <path d="M19 12H5" />
              </svg>
            </button>
          </a>
          <div>
            <h1 className="text-lg font-bold text-slate-900">
              {cityData?.city}
            </h1>
            <p className="text-xs text-slate-500">
              Explore group &amp; customized trips
            </p>
          </div>
        </div>
      </div>
      <div className="relative h-36">
        <img
          alt={cityData?.city}
          loading="lazy"
          decoding="async"
          data-nimg="fill"
          className="object-cover"
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            inset: 0,
            color: "transparent"
          }}
          src={
            cityData?.cover_image
              ? `${API_BASE}${cityData.cover_image}`
              : `${API_BASE}default.jpg`
          }
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        <div className="absolute bottom-4 left-4 right-4">
          <h2 className="text-white text-xl font-bold">{cityData?.city}</h2>
          <p className="text-white/80 text-sm">{cityData?.title}</p>
        </div>
      </div>


      {/* Tabs */}
    <div className="bg-white border-b sticky top-[57px] z-40">
      <div className="flex">
        <button
          onClick={() => setActiveTab("group")}
          className={`flex-1 py-3 text-sm font-semibold border-b-2 transition-colors ${
            activeTab === "group"
              ? "text-teal-600 border-teal-600"
              : "text-slate-500 border-transparent"
          }`}
        >
          Group Trips ({groupTrips.length})
        </button>

        <button
          onClick={() => setActiveTab("custom")}
          className={`flex-1 py-3 text-sm font-semibold border-b-2 transition-colors ${
            activeTab === "custom"
              ? "text-teal-600 border-teal-600"
              : "text-slate-500 border-transparent"
          }`}
        >
          Customized ({customTrips.length})
        </button>
      </div>
    </div>
    
      {/* Content */}
      <div className="p-4">
        {/* GROUP TRIPS */}
        {activeTab === "group" && (

           <>
           <div className="py-3 bg-white border-b">
            <div className="relative">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-search absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400"
              >
                <circle cx={11} cy={11} r={8} />
                <path d="m21 21-4.3-4.3" />
              </svg>
              <input
                className="flex w-full rounded-md border px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pl-9 h-10 bg-slate-50 border-slate-200"
                placeholder="Search trips..."
                defaultValue=""  value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>


          <div className="py-4 space-y-4">

            {loading ? (
              <p>Loading...</p>
            ) : filteredGroupTrips.length > 0 ? (
              filteredGroupTrips.map((trip) => (
                <a className="block" key={trip.id} href={`/GroupTripsDtl/${trip.id}`}>
                <div className="rounded-lg bg-card text-card-foreground overflow-hidden border-0 shadow-md">
                  <div className="relative h-52">
                    <img
                      alt={trip.name}
                      loading="lazy"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent"
                      }}
                      src={`${API_BASE}/${trip.images}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-4 left-4 bg-red-500 text-white">
                      Only {trip.spots} left
                    </div>
                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="text-white font-bold text-lg">
                        {trip.name}
                      </h3>
                      <div className="flex items-center gap-1 text-white/80 text-sm mt-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-4 w-4"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                          <circle cx={12} cy={10} r={3} />
                        </svg>
                        <span>{trip.city}</span>
                      </div>
                    </div>
                  </div>
                  <div className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4 text-sm text-slate-600">
                        <span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-clock h-4 w-4"
                          >
                            <circle cx={12} cy={12} r={10} />
                            <polyline points="12 6 12 12 16 14" />
                          </svg>
                          {trip.no_of_days}D/{trip.duration}
                        </span>
                        {/*<span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-users h-4 w-4"
                          >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx={9} cy={7} r={4} />
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                          </svg>
                          12-15
                        </span>*/}
                        <span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-star h-4 w-4 fill-yellow-400 text-yellow-400"
                          >
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                          </svg>
                          4.9
                        </span>
                      </div>
                      <div className="text-right">
                        <span className="text-sm text-slate-400 line-through">
                          ₹{trip.difficulties}
                        </span>
                        <p className="text-teal-600 font-bold text-lg">₹{trip.charges}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              ))
            ) : (
              <p>No group trips found</p>
            )}

          </div>
          </>
        )}
      

        {/* CUSTOM TRIPS */}
        {activeTab === "custom" && (
          <>
          <div className="py-3 bg-white border-b">
            <div className="relative">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-search absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400"
              >
                <circle cx={11} cy={11} r={8} />
                <path d="m21 21-4.3-4.3" />
              </svg>
              <input
                className="flex w-full rounded-md border px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pl-9 h-10 bg-slate-50 border-slate-200"
                placeholder="Search trips..."
                defaultValue=""  value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
            <div className="px-4 py-4 space-y-4">
            {loading ? (
              <p>Loading...</p>
            ) : filteredCustomTrips.length > 0 ? (
              filteredCustomTrips.map((trip) => (
                <a className="block" key={trip.id} href={`/CustomizedTripsDtl/Domestic/${trip.id}`}>
                <div className="rounded-lg bg-card text-card-foreground overflow-hidden border-0 shadow-md">
                  <div className="relative h-52">
                    <img
                      alt={trip.name}
                      loading="lazy"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent"
                      }}
                      src={`${API_BASE}/${trip.images}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-4 left-4 bg-red-500 text-white">
                      Only {trip.spots} left
                    </div>
                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="text-white font-bold text-lg">
                        {trip.name}
                      </h3>
                      <div className="flex items-center gap-1 text-white/80 text-sm mt-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-4 w-4"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                          <circle cx={12} cy={10} r={3} />
                        </svg>
                        <span>{trip.city}</span>
                      </div>
                    </div>
                  </div>
                  <div className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4 text-sm text-slate-600">
                        <span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-clock h-4 w-4"
                          >
                            <circle cx={12} cy={12} r={10} />
                            <polyline points="12 6 12 12 16 14" />
                          </svg>
                          {trip.no_of_days}D/{trip.duration}
                        </span>
                        {/*<span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-users h-4 w-4"
                          >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx={9} cy={7} r={4} />
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                          </svg>
                          12-15
                        </span>*/}
                        <span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-star h-4 w-4 fill-yellow-400 text-yellow-400"
                          >
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                          </svg>
                          4.9
                        </span>
                      </div>
                      <div className="text-right">
                      {Number(trip.charges) === 0 ? (
                         <p className="text-teal-600 font-bold text-lg">Customised</p>
                          ) : (
                            <>
                        <span className="text-sm text-slate-400 line-through">
                          ₹{trip.difficulties}
                        </span>
                        <p className="text-teal-600 font-bold text-lg">₹{trip.charges}</p>
                      </>
                      )}
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            
              ))
            ) : (
                <div className="text-center py-12">
                  <p className="text-slate-500">No customized trips found for Spiti Valley</p>
                  <a href="/customizedtrips">
                    <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 mt-4 bg-transparent">
                      Browse All Customized Trips
                    </button>
                  </a>
                </div>
            )}
          </div>
          </>
        )}
      </div>
    </>
  );
};

export default MoDestinationsDetaillist;